import AcumulatorBonusModel from './acumulator-bonus-model';

export default class Acumulator {
  constructor(data) {
    /**
     * List of acumulator bonus rules
     * @type {AcumulatorBonusModel[]}
     */
    this.accBonuses = (data.AccumulatorRules || []).map(ar => new AcumulatorBonusModel(ar))
      .sort((a, b) => b.minSelections - a.minSelections);
    /**
     * Flag wheather to include stake in bonus calculation
     * @type {boolean}
     */
    this.bonusOnPotentialWinningAmount = data.BonusOnPotentialWinningAmount || false;
    /**
     * Max bonus amount
     * @type {number}
     */
    this.maxBonus = data.MaxBonus;
  }
}
